import { baseURL } from '../components/config';

export const URI = {
  register: `${baseURL}/api/auth/register`,
  login: `${baseURL}/api/auth/login`,
  forgot_password: `${baseURL}/api/auth/forgot-password`,
  reset_password: `${baseURL}/api/auth/reset-password`,
  users: `${baseURL}/api/user/users`,
  user_settings: `${baseURL}/api/user/settings`,
  user: `${baseURL}/api/user`,
  user_by_id: (user_id) => `${baseURL}/api/user/${user_id}`,
  customers: `${baseURL}/api/customer/customers`,
  make_contact: `${baseURL}/api/contact/make-contact`,
  contacts: `${baseURL}/api/contact/contacts`,
  bulk_contact_assign: `${baseURL}/api/contact/bulk-assign`,
  change_status: `${baseURL}/api/contact/change-status`,
  contact: `${baseURL}/api/contact`,
  chat_contacts: `${baseURL}/api/contact/chat-contacts`,
  check_phone: `${baseURL}/api/contact/check-phone`,
  pinned_contact: `${baseURL}/api/contact/pinned-contact`,
  sent_message: `${baseURL}/api/message/sent`,
  sent_group_message: (group_id) => `${baseURL}/api/message/group/${group_id}/sent`,
  update_file: `${baseURL}/api/message/update-file`,
  get_messages: (contact_id) => `${baseURL}/api/message/${contact_id}`,
  mark_unread: (contact_id) => `${baseURL}/api/message/mark-unread/${contact_id}`,
  get_group_messages: (group_id) => `${baseURL}/api/message/group/${group_id}`,
  mark_as_read: (contact_id) => `${baseURL}/api/message/mark-all-read/${contact_id}`,
  assign_user: (user_id) => `${baseURL}/api/customer/assign-user/${user_id}`,
  template: `${baseURL}/api/template`,
  template_id: (id) => `${baseURL}/api/template/${id}`,
  alternate_user: `${baseURL}/api/alternate-users`,
  alternate_user_id: (id) => `${baseURL}/api/alternate-users/${id}`,
  group: `${baseURL}/api/group`,
  group_id: (id) => `${baseURL}/api/group/${id}`,
  group_members: (group_id) => `${baseURL}/api/group/${group_id}/members`,
  group_message_send_to: (batch_id) => `${baseURL}/api/group/message-to/${batch_id}`,

  // Emails
  user_creds: `${baseURL}/api/email/user-creds`,
  new_account: `${baseURL}/api/email/new-account`,
  account_approved: `${baseURL}/api/email/account-approved`,
  password_changed: `${baseURL}/api/email/password-changed`,
  reset_password_email: `${baseURL}/api/email/reset-password`,
  assign_contact: `${baseURL}/api/email/assign-contact`,
};
